<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->

    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <app-page-banner class="small-banner"title="Embracing Mental Wellbeing in a Changing World" subtitle="Embracing Mental Wellbeing in a Changing World"></app-page-banner>
        <!-- INNER PAGE BANNER END -->


       <div class="container pt-2 pb-5">
                <div class="row">
                    <!-- Left Side: Image -->
                    <div class="col-lg-6 col-md-12 m-b10">
                        <div class="image-container text-center mt-4 mb-4">
                            <img src="assets/images/an-asian-woman-holds-a-globe-in-green-forest-symbo-2024-10-12-00-07-02-utc.jpg" alt="Welcome to Soul Space" class="img-fluid rounded-img shadow-img">
                        </div>
                    </div>
                
                    <!-- Right Side: Text Content -->
                    <div class="col-lg-6 col-md-12">
                        <div class="text-content" style="position: relative;bottom: 14px;">
                            <div class="separator-line mb-4"></div>
                            <!-- <h5>Embracing Mental Wellbeing in a Changing World</h5> -->
                            <p >
                                The rapid technological advances of recent decades have profoundly impacted our individual and collective lifestyles. These changes necessitate a restructuring of our belief systems, urging us to place mental and emotional wellbeing on par with physical health, rather than viewing it as a distant corollary of “good physical health”.
                                <br><br>In recent years, there has been a global shift in how we perceive wellbeing. India took a pioneering step in 2011 by attempting to put mental health on the WHO agenda when only non-communicable diseases were given importance. This effort culminated on May 2,2016, when the then UN Secretary General António Guterres launched mental health as a flagship program.
                                <br><br>Soul Space was born from the global awakening, formed in December, 2023, we are a registered entity of dedicated mental health professionals united by a common cause: to bring the benefits of positive mental health and wellbeing to the general population.
                            
                
                            
                        </div>
                    </div>
                </div>
            </div>
    </div>
    <!-- CONTENT END -->

    <app-footer1></app-footer1>
    
</div>

<app-loader></app-loader>